import { isDefined } from "@clipboard-health/util-ts";
import { useSession } from "@src/appV2/Auth/api/useSession";
// eslint-disable-next-line no-restricted-imports
import { initBraze } from "@src/utils/braze";
import constate from "constate";
import { useEffect, useMemo, useState } from "react";

interface BrazeContextValue {
  brazeInitialized: boolean;
}

export interface BrazeProviderProps {
  isAdminSession: boolean;
  isWorkplace: boolean;
}

export function useBrazeInitialized(props: BrazeProviderProps): BrazeContextValue {
  const { isAdminSession, isWorkplace } = props;

  const session = useSession();

  const [brazeInitialized, setBrazeInitialized] = useState(false);

  useEffect(() => {
    async function load() {
      setBrazeInitialized(false);
      const brazeUserId = session?.admin ? session?.profile?.userId : session?.user?._id;
      if (isDefined(brazeUserId)) {
        await initBraze(brazeUserId);
        setBrazeInitialized(true);
      }
    }

    // Initialize for authenticated workplace, or the workplace an admin is impersonating
    if (!isAdminSession || isWorkplace) {
      void load();
    }
  }, [isAdminSession, isWorkplace, session?.admin, session?.profile?.userId, session?.user?._id]);

  const contextValue = useMemo(() => ({ brazeInitialized }), [brazeInitialized]);

  return contextValue;
}

export const [BrazeInitializedProvider, useBrazeInitializedProviderContext] =
  constate(useBrazeInitialized);
